import styled from 'styled-components';
import { StyledAdminListHeaders } from '../../AdminListHeaderCell/styles/StyledAdminListHeaders';

export const StyledAdminDeviceGroupsListHeader = styled.div`
  ${StyledAdminListHeaders}

  .admin-list-header-cell-container {
    &.adjust {
      width: 19rem;
      flex-grow: initial;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
